import React, { useEffect, useReducer, useContext } from "react";
import { useHistory, useParams } from 'react-router-dom'
import axios from "axios";
import { CircularProgress } from '@material-ui/core'

import AuthContext from "../../../context/auth-context"
import { dataFetchReducer } from "../../Utils/requestUtils";
import ClientProfile from "./ClientProfile/ClientProfile";
import ErrorBoundary from "../../Utils/ErrorBoundary";

function RegistrationDataValidation(props) {
    let history = useHistory()
    let user_data = useContext(AuthContext).user_data

    if (!user_data.roles.includes("read_registration_data_validations"))
        history.push("")

    let { event_key } = useParams()

    const [registrationDataValidation, dispatchRegistrationDataValidation] = useReducer(
        dataFetchReducer,
        {
            fetchedData: null, isLoading: true, isError: false
        }
    )

    useEffect(() => {
        dispatchRegistrationDataValidation({ type: "data_fetch_init" })
        const timer = setTimeout(() => {
            axios.get('/dash/account_event/registration_data_validation/' + event_key).then(response => {
                dispatchRegistrationDataValidation({
                    type: "data_fetch_success",
                    payload: response.data
                })
            }).catch(error => {
                if ((error.response || {}).status === 403) dispatchRegistrationDataValidation({ type: "data_fetch_failure_403" })
                else if ((error.response || {}).status === 404) dispatchRegistrationDataValidation({ type: "data_fetch_failure_404" })
                else dispatchRegistrationDataValidation({ type: "data_fetch_failure" })
            })
        }, 500);
        return () => {
            clearTimeout(timer)
        }
    }, [event_key])

    if (registrationDataValidation.fetchedData) {

        return <div style={{ display: "flex", margin: "10px 0px" }}>
            <div className="analysisCardContainer" style={{ flexGrow: "1", display: 'flex', flexDirection: 'column' }}>
                <ErrorBoundary>
                    <ClientProfile registration_data_validation={registrationDataValidation.fetchedData} />
                </ErrorBoundary>
            </div>
        </div>
    }

    else if (registrationDataValidation.isLoading) {
        return (
            <div style={{ width: "auto" }}>
                <div className='circularProgressCenter'>
                    <CircularProgress />
                </div>
            </div>
        )
    }
    else if (registrationDataValidation.isError) {
        return (
            <div style={{ height: "80vh", display: "flex" }}>
                <p className={["blueText", "titleSize"].join(" ")} style={{ margin: "auto", textAlign: "center" }}>
                    {registrationDataValidation.errorMessage}
                </p>
            </div>
        )
    }

    return <div className="analysisCardContainer" style={{ flexGrow: "1", display: 'flex', flexDirection: 'column' }}>
        Erro ao buscar informações
    </div>
}

export default RegistrationDataValidation;